var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconDownloadWhite(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M2 13.333C2 12.9648 2.29848 12.6663 2.66667 12.6663H13.3333C13.7015 12.6663 14 12.9648 14 13.333C14 13.7012 13.7015 13.9997 13.3333 13.9997H2.66667C2.29848 13.9997 2 13.7012 2 13.333ZM8.66667 8.78101L12.2427 5.20441C12.503 4.94407 12.925 4.94405 13.1854 5.20437C13.4457 5.46467 13.4457 5.88669 13.1854 6.147L8.4714 10.8615C8.21106 11.1219 7.78893 11.1219 7.52857 10.8616L2.81457 6.14758C2.55429 5.88729 2.55433 5.4652 2.81452 5.20482C3.07483 4.94433 3.49715 4.94412 3.75757 5.2045L7.33333 8.77967V1.99967C7.33333 1.63148 7.63181 1.33301 8 1.33301C8.36819 1.33301 8.66667 1.63148 8.66667 1.99967V8.78101Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconDownloadWhite);
export default __webpack_public_path__ + "static/media/icon-download-white.a002398269a0e00e6ccba347a27634e1.svg";
export { ForwardRef as ReactComponent };